import { 
    Grid, 
    Typography, 
    TextField,
} from '@mui/material';

export default function FrameSectionPatientOwn({ 
    frameData, 
    inProgress,
    onFrameDataChange
}) {
    const patientOwnFrame = frameData.frameDetails?.patientOwnFrame || {};

    const setPatientOwnField = (field, value) => {
        onFrameDataChange && onFrameDataChange(`frameDetails.patientOwnFrame.${field}`, value);
    };

    return (
        <Grid container spacing={1} p={1} boxShadow={2} sx={{ mb: 2, border: '1px solid #ccc', borderRadius: 1 }}>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Model #"
                    variant="outlined"
                    size="small"
                    value={patientOwnFrame.modelNumber || ''}
                    onChange={(e) => setPatientOwnField('modelNumber', e.target.value)}
                    inputProps={{ style: { textTransform: 'uppercase' },}}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Brand"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={patientOwnFrame.brand || ''}
                    onChange={(e) => setPatientOwnField('brand', e.target.value)}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    label="Color"
                    variant="outlined"
                    size="small"
                    value={patientOwnFrame.frameColorCode || patientOwnFrame.frameColor || ''}
                    onChange={(e) => setPatientOwnField('frameColorCode', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Material"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={patientOwnFrame.material || ''}
                    onChange={(e) => setPatientOwnField('material', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Rim Type"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={patientOwnFrame.rimType || ''}
                    onChange={(e) => setPatientOwnField('rimType', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Shape"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={patientOwnFrame.shape || ''}
                    onChange={(e) => setPatientOwnField('shape', e.target.value)}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField label="A" variant="outlined" size="small"  fullWidth value={patientOwnFrame.aMeasurement || ''} onChange={(e) => setPatientOwnField('aMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="B" variant="outlined" size="small"  fullWidth value={patientOwnFrame.bMeasurement || ''} onChange={(e) => setPatientOwnField('bMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="ED" variant="outlined" size="small"  fullWidth value={patientOwnFrame.edMeasurement || ''} onChange={(e) => setPatientOwnField('edMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="DBL" variant="outlined" size="small"  fullWidth value={patientOwnFrame.dblMeasurement || ''} onChange={(e) => setPatientOwnField('dblMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="Eye" variant="outlined" size="small"  fullWidth value={patientOwnFrame.eyeSize || ''} onChange={(e) => setPatientOwnField('eyeSize', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="Temp" variant="outlined" size="small"  fullWidth value={patientOwnFrame.templeLength || ''} onChange={(e) => setPatientOwnField('templeLength', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    variant="filled"
                    size="small"
                    label="Price"
                    type='text'
                    
                    value={`${frameData.listPrice || '0.00'}`}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('listPrice', e.target.value)}
                    //onChange={(e) => setFramePrice(e.target.value)}
                    InputProps={{ startAdornment: <Typography sx={{ mr: 1 }}>$</Typography> }}
                />
            </Grid>
        </Grid>
    );
}